// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.invite-bean {\r\n  display: inline-block;\r\n  width: 0.37333rem;\r\n  height: 0.37333rem;\r\n  vertical-align: middle;\n}\n.invite2-tips-wrapper {\r\n  max-width: 5.86667rem;\r\n  padding: 0.21333rem 0.26667rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
